export const validateCsv = (file, token, subsidiaryId) => ({
  headers: {
    'X-Authentication-Token': token,
    Authorization: token,
    'x-lang': 'es',
  },
  endpoint: '/api/v1/email-ecommerce-manager/campaigns/validate-file',
  method: 'POST',
  formData: {
    Resource: file,
    SubsidiaryId: subsidiaryId,
  },
  proxy: false,
});

export const confirmCampaign = (campaignId, campaignName, token) => ({
  headers: {
    'X-Authentication-Token': token,
    'Content-Type': 'application/json',
    Authorization: token,
    'x-lang': 'es',
  },
  endpoint: '/api/v1/email-ecommerce-manager/campaigns',
  method: 'POST',
  data: { campaignId, campaignName },
  proxy: false,
});



